export default {
  invoice: "Invoices",
  contract: "Contracs",
  offer: "Offers",
  insurance: "Insurances",
};
